<template>
  <div class="t">
    <span class="t-tip1">
      <iconpark-icon name="zhanghaomimadenglu"></iconpark-icon>
    </span>
    <div class="t-icon" @click="handleClick">
      <iconpark-icon name="computer1"></iconpark-icon>

      <!-- <airplay theme="outline" size="24" fill="#333"/> -->
      <!-- <iconpark-icon name="computer"></iconpark-icon> -->
      <!-- <iconpark-icon name="computercopy"></iconpark-icon> -->
    </div>
    <div class="t-form">
      <h2 class="t-title">扫码登录</h2>
      <p class="t-tip2">{{title}}</p>
      <div class="t-qrcode" v-show="!isTimeout" ref="qrCodeUrl"></div>
      <div class="t-qrcode reload" v-show="isTimeout">
        <a-icon type="sync" :spin="spin" class="reload-icon" @click="createSignInQRCode" />
      </div>
    </div>
  </div>
</template>

<script>
const AV = require('leancloud-storage')
import QRCode from 'qrcodejs2'
export default {
  name: 'Qrcode',
  data() {
    return {
      timer: null,
      isLoginConfirm: false,
      isTimeout: false,
      spin: false,
      title: '',
      tip: {
        'non-scan': '请使用 [我的物品] App扫描二维码',
        scan: '请在 [我的物品] App上确认登录',
        confirm: '确认成功',
        loading: '登录中...',
        jump: '跳转中...',
        fail: '登录失败，请刷新后重试',
      },
      index: 0,
      qrcode: null,
    }
  },
  mounted() {
    this.createSignInQRCode()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    createSignInQRCode() {
      const option = { token: '05XmTKtCFOzJd134Po06EkSy7FjYZa' }
      this.spin = true
      AV.Cloud.run('createSignInQRCode', option)
        .then((res) => {
          this.spin = false
          this.creatQrCode(res.qrCode)
          this.fetchSignInQRCodeUser(res.qrCode)
        })
        .catch((err) => {
          this.spin = false
          const msg = err.message.replace(/\[.*?\]/g, '')
          this.$message.error(msg)
        })
    },
    login(token) {
      this.loading = true
      this.title = this.tip.loading
      AV.User.become(token).then(
        () => {
          this.loading = false
          this.title = this.tip.jump
          this.$router.push({ path: `/house` })
        },
        (err) => {
          const msg = err.message.replace(/\[.*?\]/g, '')
          this.$message.error(msg)
          this.title = this.tip.fail
        }
      )
    },
    fetchSignInQRCodeUser(data) {
      if (!this.timer) {
        const option = { qrCode: data, token: '05XmTKtCFOzJd134Po06EkSy7FjYZa' }
        this.timer = setInterval(() => {
          if (!this.isLoginConfirm) {
            this.index++
            if (this.index === 15) {
              console.log('二维码过期')
              clearInterval(this.timer)
              this.qrcode.clear()
              this.index = 0
              this.isTimeout = true
              this.timer = null
            }
            AV.Cloud.run('fetchSignInQRCodeUser', option)
              .then((res) => {
                this.title = this.tip[res.status]
                if (res.status === 'confirm') {
                  this.isLoginConfirm = true
                  this.login(res.sessionToken)
                  clearInterval(this.timer)
                }
              })
              .catch((err) => {
                clearInterval(this.timer)
                const msg = err.message.replace(/\[.*?\]/g, '')
                this.$message.error(msg)
              })
          } else {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    creatQrCode(data) {
      this.isTimeout = false
      if (this.qrcode) {
        this.qrcode.makeCode(data)
      } else {
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: data, // 需要转换为二维码的内容
          width: 160,
          height: 160,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      }
    },
    handleClick() {
      this.$emit('handleClick', 'PasswordComponent')
    },
  }
}
</script>
<style scoped lang="less">
.t {
  &-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    top: 10px;
    font-size: 60px;
  }
  &-form {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }
  &-tip1 {
    position: absolute;
    right: 65px;
    top: -37px;
    font-size: 99px;
  }
  &-title {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #444444;
    line-height: 34px;
    letter-spacing: 2px;
    margin-bottom: 6px;
  }
  &-tip2 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #444444;
    line-height: 18px;
    margin-bottom: 30px;
  }
  &-qrcode {
    width: 160px;
    height: 160px;
    // background: #ffb547;
    margin: auto;
  }
}
.reload {
  background: #00000069;
  text-align: center;
  color: #fff;
  &-icon {
    font-size: 24px;
    vertical-align: middle;
    /* margin: auto; */
    position: relative;
    top: 50%;
    margin-top: -24px;
    cursor: pointer;
  }
}
</style>
